import { render } from "./Not404Found.vue?vue&type=template&id=a865c17a&scoped=true"
import script from "./Not404Found.vue?vue&type=script&lang=js"
export * from "./Not404Found.vue?vue&type=script&lang=js"

import "./Not404Found.vue?vue&type=style&index=0&id=a865c17a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a865c17a"]])

export default __exports__